var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticClass: "select-content-dialog",
      attrs: {
        title: "Select Content",
        visible: _vm.dialogVisible,
        width: "auto",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.onOpen,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "padding-lr" },
        [
          _c(
            "PageHeader",
            { attrs: { line: false } },
            [
              _c("el-input", {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: _vm.onSearch,
                    expression: "onSearch",
                  },
                ],
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search",
                  clearable: "",
                },
                on: { clear: _vm.onSearch },
                model: {
                  value: _vm.searchVal,
                  callback: function ($$v) {
                    _vm.searchVal = $$v
                  },
                  expression: "searchVal",
                },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "table",
              attrs: {
                data: _vm.tableData,
                height: "50vh",
                "element-loading-text": "Loading...",
              },
              on: {
                select: _vm.handleSelect,
                "select-all": _vm.handleSelectionAll,
                "sort-change": _vm.onSortChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "45",
                  align: "center",
                  selectable: _vm.selectableHandler,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CategoryName",
                  label: "Category",
                  sortable: "custom",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ShortTitle",
                  label: "Short Title",
                  sortable: "custom",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "DocumentTitle",
                  label: "Content Title",
                  sortable: "custom",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "SearchTerm",
                  label: "Search Term",
                  sortable: "custom",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CreatedOn",
                  label: "Create Date",
                  sortable: "custom",
                  width: "140",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "pagination-wrap" }, [
            _c(
              "div",
              { staticClass: "actions" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 25, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: _vm.multipleSelection.length === 0,
              },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(" Select ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }